<template>
    <div class="page">
      <div class="password-wrapper">
  
  
        <div class="pass-box">
          <h3 class="checkEmail"> {{$t('personal_info')}} </h3>
          <div class="lineClass"></div>
     
          <p class="addPasswordText">{{ $t("add_name_and_type") }}</p>
          <div class="fullName_userType">
            <input
              type="text"
              v-model="full_name"
              :placeholder="$t('enter_full_name')"
              required
            />
            <div class="custom_select">
            <!-- <select name="userTypeSelect" id=""> 
                <option value="Individual">{{ $t('individual') }}</option>
                <option value="Organisation">{{ $t('agency') }}</option>

            </select> -->

            <v-select
        :items="[{ name: 'individual' }, { name: 'agency' }]"
        @keyup.enter = "nextStep"
        ref="user_type"
        :placeholder="$t('user_type_text')"
        outlined
        class="login-input"
        :item-text="(val) => ($t(`mainFilters.${val.name}`))"
        color="#04a777"
        v-model="user_type"

      ></v-select>

            </div>
          </div>
          <button :disabled="!isAllChecksPassed" @click="nextStep">
              {{ $t('next') }}
            </button>
        </div>
        </div>
  
  
      </div>
  </template>
  
  
  <script>
  
  export default {
    
    data() {
      return {
        full_name: '',
        user_type:''
      };
    },
    computed: {

        isAllChecksPassed() {
      const result = this.full_name.trim().length > 1 && this.user_type;
      return result;
    }
    },
    methods: {
      
      nextStep() {
        if (this.isAllChecksPassed) {
          this.$store.commit('registration/SET_FULLNAME',this.full_name)
          this.$store.commit('registration/SET_USERTYPE',this.user_type)
          this.$emit('next');
        }
      }
    }
  };
  </script>
  
  
  
  <style scoped>
  .page {
    width: 100%;
    height: 100vh;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0 !important;
  }
  
  .password-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 70px;
  }
  h3{
    text-align: center;
  }
  .pass-box {
    width: 100%;
    max-width: 671px;
    padding: 20px 0px;
    border: 1px solid #ddd;
    box-shadow: 5px 5px 15px rgba(78, 78, 78, 0.493);
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .fullName_userType {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin: 0 auto;
  }
  
  input[type="text"] {
    width: 100%;
    padding: 15px;
    padding-right: 40px;
    margin-bottom: 10px;
    border: 1px solid #919191;
    border-radius: 4px;
  }
  
  .toggle-visibility {
    position: absolute;
    right: 10px;
    top: 40%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  .password-feedback {
    font-size: 14px;
    padding: 0px 62px;
  }
  
  .check-item {
    display: flex;
    align-items: center;
    margin: 5px 0;
    padding: 5px;
    border-radius: 4px;
  }
  .checkEmail{
      font-weight: bold;
      font-size: 18px;
      line-height: 24.55px;
      margin-bottom: 15px;
  }
  .lineClass{
      width: 100%;
      height: 4px;
      background-color: #04a777;
      margin-bottom: 25px;
  }
  .addPasswordText{
    text-align: center;
    padding: 0 7px;
  }
  
 
  
  button {
    width: 196px;
    padding: 10px;
    border: none;
    border-radius: 4px;
    background-color: #04a777;
    color: white;
    cursor: pointer;
    margin: 20px auto;
  }
  
  button:disabled {
    background-color: #84cab5;
    cursor: not-allowed;
  }
  .custom_select{
     border: 1px solid rgb(214, 214, 214);
     border-radius: 5px;
     padding: 10px;
     width: 100%;
     min-width: 100%;
  }
  .custom_select select{
    width: 100%;
    color: rgb(105, 104, 104);
  }
  select option{
    margin-top: 10px;
    padding: 10px;
  }
  
 option {
    padding: 10px !important;
    background-color: #fff;
    color: #696868;
    font-size: 14px;
    font-family: 'Arial', sans-serif;
  }

  select:focus option {
    background-color: #f0f0f0; /* Changes the background when an option is selected */
  }

  .custom_select{
    border: none;
    padding: 0;
  }
  .v-select__slot .v-select__selections{
    padding: 0 !important;
  }

  
  </style>
  